module.exports = __webpack_public_path__ + "static/img/Youtube.66d6d3af.jpg";